import { config } from "firebaseConfig"

export type ENV_TYPE = "prod" | "dev"

export const getCurrentEnv = (): ENV_TYPE => {
    return (config.projectId == "safetycheck-dev") ? "dev" : "prod"
}